import React, {Component} from 'react'
import PropTypes from 'prop-types'

class ItemSideDefault extends Component {
    state = {
        visible: false,
    }

    _hide = () => {
        this.setState({
            visible: false,
        })
    }

    _handleVisibleChange = visible => {
        this.setState({visible})
    }


    render() {
        const {side, url} = this.props

        return (
            <div className='ItemSideDefault border rounded bg-white'>
                <div className='px-2 py-1'>{side}</div>
                <div className='border-top'>
                    {
                        url &&
                        <a href={url} target='_blank' rel='noreferrer noopener'>
                            <span className='Icon View p-2' title='View'><i className='fa fa-eye'/></span>
                        </a>
                    }
                </div>
            </div>
        )
    }
}

ItemSideDefault.defaultProps = {
    url: '',
}

ItemSideDefault.propTypes = {
    side: PropTypes.string.isRequired,
    url: PropTypes.string,
    orderId: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['update-design', 'update-mock-up']),
}

export default ItemSideDefault
